import React from 'react';
import { T } from 'shared/helper/translate';
var SubscriptionErrorMessage = function SubscriptionErrorMessage(_ref) {
  var message = _ref.message,
    onLinkClick = _ref.onLinkClick;
  var handleLinkClick = function handleLinkClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (onLinkClick) {
      onLinkClick();
    }
  };
  var isPaymentDeclined = message.message === 'payment-declined';
  var beforeMessage = isPaymentDeclined ? 'rubriq.subscription-start-failed-payment-declined-before' : 'rubriq.subscription-start-failed-consent-required-before';
  var afterMessage = isPaymentDeclined ? 'rubriq.subscription-start-failed-payment-declined-after' : 'rubriq.subscription-start-failed-consent-required-after';
  return /*#__PURE__*/React.createElement("span", {
    className: "subscription-error-message"
  }, /*#__PURE__*/React.createElement(T, {
    source: beforeMessage
  }), ' ', /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "subscription-error-message__link",
    onClick: handleLinkClick
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.change-billing-information"
  })), ' ', /*#__PURE__*/React.createElement(T, {
    source: afterMessage
  }));
};
export default SubscriptionErrorMessage;